
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.717 3.795a1.26 1.26 0 00-1.434 0l-7.14 4.917c-.333.23-.536.6-.55.996-.052 1.372-.107 3.774.044 5.48.113 1.286.416 2.987.662 4.238a1.24 1.24 0 001.221 1.002h3.324a.26.26 0 00.257-.262v-4.19c0-1.013.803-1.834 1.795-1.834h2.513c.991 0 1.795.82 1.795 1.833v4.191a.26.26 0 00.256.262h3.02a1.24 1.24 0 001.22-1.002c.247-1.251.55-2.952.663-4.238.151-1.706.096-4.108.044-5.48a1.269 1.269 0 00-.55-.996l-7.14-4.917zm-2.293-1.303a2.771 2.771 0 013.152 0l7.14 4.917a2.848 2.848 0 011.229 2.238c.052 1.37.111 3.865-.05 5.682-.121 1.378-.439 3.15-.686 4.406A2.787 2.787 0 0118.479 22H15.46c-.99 0-1.795-.82-1.795-1.834v-4.19a.26.26 0 00-.256-.263h-2.513a.26.26 0 00-.257.262v4.191C10.64 21.18 9.836 22 8.844 22H5.52a2.787 2.787 0 01-2.729-2.265c-.247-1.256-.565-3.028-.687-4.406-.16-1.817-.1-4.311-.049-5.682.035-.91.5-1.736 1.228-2.238l7.14-4.917z","fill":"currentColor"}})])
          )
        }
      }
    